import { IsNumber, Min, Max, IsDefined } from 'class-validator';

export class RgbaDto {
  @IsDefined()
  @IsNumber()
  @Min(0)
  @Max(255)
  r!: number;

  @IsDefined()
  @IsNumber()
  @Min(0)
  @Max(255)
  g!: number;

  @IsDefined()
  @IsNumber()
  @Min(0)
  @Max(255)
  b!: number;

  @IsDefined()
  @IsNumber()
  @Min(0)
  @Max(1)
  a!: number;
}
